import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=1870b757&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1870b757",
  null
  
)

export default component.exports